import { render, staticRenderFns } from "./Gastrointestinal.vue?vue&type=template&id=533fa031&scoped=true"
import script from "./Gastrointestinal.vue?vue&type=script&lang=js"
export * from "./Gastrointestinal.vue?vue&type=script&lang=js"
import style0 from "./Gastrointestinal.vue?vue&type=style&index=0&id=533fa031&prod&lang=scss&scoped=true"
import style1 from "./Gastrointestinal.vue?vue&type=style&index=1&id=533fa031&prod&lang=scss&scoped=true"
import style2 from "./Gastrointestinal.vue?vue&type=style&index=2&id=533fa031&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533fa031",
  null
  
)

export default component.exports